<template>
  <div v-if="storeStakeholder.authorZoom" class="englobe-datas">
    <div class="stakeholders-zoom-author">
      <AuthorCardWithAllMedia :author="storeStakeholder.authorZoom" />
    </div>
    <RouterView />
  </div>
  <NoData v-else />
</template>

<script setup>
import AuthorCardWithAllMedia from "@follaw-fr/components/social-media/stakeholders/molecules/AuthorCardWithAllMedia.vue";
import NoData from "@follaw-fr/components/reusable/atoms/NoData.vue";
import { useStakeholdersStore } from "@follaw-fr/stores/social-media/stakeholders";
import { useUserSettingsStore } from "@follaw-fr/stores/user-settings";
import { PermissionLevel } from "@/follaw-fr/constants/enums/permission-level.enum";

const storeStakeholder = useStakeholdersStore();
const userSettingsStore = useUserSettingsStore();

// Empty mentions array before mentions fetching.
storeStakeholder.zoomMentions = [];
storeStakeholder.zoomMentionsCount = 0;
if (
  userSettingsStore.hasPermission(PermissionLevel.SOCIETAL) &&
  storeStakeholder.authorZoom.x_information
) {
  storeStakeholder.zoomMentionsFilters.from = 0;
  storeStakeholder.getMentionsOfPublications(
    storeStakeholder.authorZoom.x_information?.username
  );
}
</script>

<style scoped lang="scss">
.englobe-datas {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 8px;
  padding-top: 10px;
}

@media (max-width: 1360px) {
  .englobe-datas {
    grid-template-columns: 1fr;
  }
}

.stakeholders-zoom-author {
  min-width: 0;
}
</style>
